import React from 'react';
import PropTypes from 'prop-types';

import Grid from 'material-ui/Grid';
import { withStyles } from 'material-ui/styles';
import { materialToChartData } from '../../../../lib/material';
import MaterialChart from '../../../common/MaterialChart';
import { DK_DECIMALS, DF_DECIMALS } from '../../../../constants/globals';
import { materialPropType } from '../../../../lib/shapes';

const styles = theme => ({
  root: {
    minHeight: 370,
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
    overflowY: 'visible',
  },
  container: {
    margin: 'auto'
  }
})

export const DkdfCharts = (props) => {
  const { classes, materials, lengthUnit  } = props;
  const dk = materialToChartData(materials, 'dk', DK_DECIMALS, lengthUnit);
  const df = materialToChartData(materials, 'df', DF_DECIMALS, lengthUnit);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={12} md={6}>
        <MaterialChart data={dk.data} keys={dk.keys} mhzs={dk.mhzs} label="Dk" />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <MaterialChart data={df.data} keys={df.keys} mhzs={df.mhzs} label="Df" />
      </Grid>
    </Grid>
  );
}

DkdfCharts.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    container: PropTypes.string,
  }).isRequired,
  materials: PropTypes
    .arrayOf(PropTypes.shape(materialPropType))
    .isRequired,
  lengthUnit: PropTypes.string.isRequired,
}

export default  withStyles(styles)(DkdfCharts);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/MaterialsViewer/DkDfCharts.jsx